<template>
<div class="">
	<div class="wx-pay-2024-4body">
	<div class="wx-pay-2024" v-if="!isPay">
	<div class="wx-pay-2024-1">
		<img src="http://hy.xiaoqinhaishen.com/syspay/1 (9).png" class="wx-pay-2024-2" alt="">
	</div>
	<ul class="wx-pay-2024-3">
		<li class="pad line-am">
			<p class="wx-pay-2024-4">￥{{order.amount || 0}}</p>
		</li>
		<li class="pad wx-pay-2024-5">
			<span><b style="color:red">*</b> 金额(元)</span>
			<div class="fr">
				<input autocomplete="off" class="font_c ipt" type="text" placeholder="请输入金额(元)" v-model="order.amount">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad wx-pay-2024-5">
			<span><b style="color:red">*</b> 手机号</span>
			<div class="fr">
				<input autocomplete="off" class="font_c ipt" type="text" placeholder="请输入手机号" v-model="order.smobile">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad wx-pay-2024-6" v-if="!showMore">
			<p><a v-on:click="showMoreInfo">填写额外信息&gt;</a></p>
		</li>
		<li class="pad wx-pay-2024-5" v-if="showMore">
			<span>姓名</span>
			<div class="fr">
				<input autocomplete="off" class="font_c ipt" type="text" placeholder="请输入姓名" v-model="order.linkman">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad wx-pay-2024-5" v-if="showMore">
			<span>备注</span>
			<div class="fr">
				<input autocomplete="off" class="font_c ipt" type="text" placeholder="请输入备注" v-model="order.note">
				<img src="/static/rt.png" v-if="false" alt="">
			</div>
		</li>
		<li class="pad btn-group">
			<a href="javascript:;" @click="submitOrder" class=" wx-pay-2024-7"><img src="http://hy.xiaoqinhaishen.com/syspay/1 (2).png" class="wx-pay-2024-8" alt=""></a>
		</li>
	</ul>
	<a-result
	v-if="isPay"
    status="success"
    :title="'单号：'+result.bill"
    :sub-title="'您的订单已经支付完成！支付金额：' + result.am + '元'"
  >
    <template #extra>
      <!-- a-button key="console" type="primary">
        Go Console
      </a-button>
      <a-button key="buy">
        Buy Again
      </a-button -->
    </template>
  </a-result>

	</div>
</div>

	<div class="wx-pay-2024-20" v-if="isPay">
	<div class="wx-pay-2024-10">
		<img src="http://hy.xiaoqinhaishen.com/syspay/1 (8).png" class="wx-pay-2024-4-6" alt="">
	</div>
	<ul class="wx-pay-2024-4-1">
		<li class="pad line-am">
			<p class="wx-pay-2024-4-3">支付成功</p>
		</li>
		<li class="pad line-am">
			<p class="wx-pay-2024-4-2">成功支付：{{result.am }}元</p>
		</li>
		<li class="pad line-am">
			<p class="wx-pay-2024-4-5">单号：{{ result.bill }}元</p>
		</li>
	</ul>
	</div>
</div>
</template>

<script>
import querystring from 'querystring';
import jwx from '@/api/jwx'
import {
  SysPay_StartPay,
  WxPay_WxAppKey,
  WxPay_WxCallBack,
  Current
} from "@/api/api.js"

export default {
  data () {
    return {
		order:{
			emp:'',
			linkman:'',
			smobile:'',
			amount:'',
			note:'',
			iddep:'',
			platform:'',
			openid:'',
			url:'',
		},
		result:{
			bill:'',
			amount:0
		},
		isPay:false,
		showMore:false
    }
  },
  methods:{
	showMoreInfo:function(){
		this.showMore = true;
	},
	  submitOrder:function(){
		  let that = this;
		  if(!that.order.platform){
			  that.$message.error('请使用微信或者支付宝扫一扫！');
			  return;
		  }
		  if(!that.order.smobile){
			  that.$message.error('请输入手机号');
			  return;
		  }
		  var am = parseFloat(that.order.amount);
		  if(isNaN(am) || am <= 0){
			  that.$message.error('请输入金额！');
			  return;
		  }
		  SysPay_StartPay(that.order,function(res){
			  //alert(JSON.stringify(res));
			  if(res.code == 500){
				that.$message.error(res.message);
			  }
			  else{
				  if(that.order.platform == 'alipay'){
					  location.href = `/api/SysPay/CallAlipay?orderid=${res.model}&iddep=${that.order.iddep}`;
				  }
				  else{
					that.result.bill = res.model;
				  	jwx.wxpay(res.extand,function(res1){
						//alert(JSON.stringify(res));
						if(res1.code == 200){
							that.result.am = that.order.amount;
							that.isPay = true;
						}
						else{
							that.$message.error("支付已经取消！");
						}
					});
				  }
			  }
		  })
	  },
		uuid:function () {
			var s = [];
			var hexDigits = "0123456789abcdef";
			for (var i = 0; i < 36; i++) {
				s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
			}
			s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
			s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
			s[8] = s[13] = s[18] = s[23] = "-";

			var uuid = s.join("");
			return uuid;
		}
  },
  created:function(){
	  let that = this;
	  let options = querystring.parse(location.search.replace('?', ''));
	  let bill = options.bill;
	  let am = options.am;
	  if(bill && am){
		that.isPay = true;
		that.result.bill = bill;
		that.result.am = am;
		  
		return;
	  }
	  else{

	  }

	  that.order.iddep = options.id;
	  that.order.emp = options.emp;

		var ua = window.navigator.userAgent.toLowerCase();
		if(ua.match(/MicroMessenger/i) == 'micromessenger') {
			let code = options.code;
			let state = options.state;
			if(!code || !state){
				WxPay_WxAppKey({iddep:that.order.iddep},function(res){
					location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.model}&redirect_uri=${window.encodeURIComponent(location.origin + '/syspay?id=' + options.id + '&emp=' + options.emp)}&response_type=code&scope=snsapi_base&state=${that.uuid()}#wechat_redirect`
				})
			}
			else {
				WxPay_WxCallBack({iddep:that.order.iddep,code:code,state:state},function(res){
					if(res.code == 200){
						that.order.openid = res.model;
						that.order.url = document.URL.split('#')[0];
					}
					else{
						WxPay_WxAppKey({iddep:that.order.iddep},function(res){
							location.href =`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.model}&redirect_uri=${window.encodeURIComponent(location.origin + '/syspay?id=' + options.id + '&emp=' + options.emp)}&response_type=code&scope=snsapi_base&state=${that.uuid()}#wechat_redirect`
						})
					}
				})
			}
			that.order.platform='wechat';
		} else if(ua.match(/Alipay/i)=="alipay"){   
			that.order.platform = 'alipay';
		}
		else{
			that.$message.error('请使用微信或者支付宝扫一扫！');
		}

		Current({},function(res){
			if(res.code == 200){
				that.order.linkman = res.model.sname;
				that.order.smobile = res.model.smobile;
			}
		})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wx-pay-2024-4body{background:#D7000F !important;}
img.wx-pay-2024-2 {width: 100%;}
ul.wx-pay-2024-3 {background: linear-gradient( 180deg, #EDEDED 0%, #FFFFFF 100%);box-shadow: inset 0px 2px 0px 0px rgba(255,255,255,0.5);border-radius: 40px 40px 0px 0px;}
.wx-pay-2024-4 {font-family: AlibabaPuHuiTi_2_55_Regular;font-size: 50px;color: #000000;line-height: 64px;text-align: center;font-style: normal;padding-top: 20px;margin-bottom: 20px;}
img.wx-pay-2024-8 {width: 100%;}
li.pad.wx-pay-2024-5 {background: #FFFFFF;border-radius: 16px;display: flex;margin-bottom: 20px;margin: 0 20px;margin-bottom: 20px;padding: 0 10px;}
li.pad.wx-pay-2024-5 input {border: none;}
li.pad.wx-pay-2024-6 a {font-size: 13px;color: #CD612D;line-height: 40px;text-align: center;font-style: normal;}
li.pad.wx-pay-2024-6 {text-align: center;}
li.pad.wx-pay-2024-5 .fr {flex: 1;}
li.pad.wx-pay-2024-5 .fr input {display: block;text-align: right;width: 100%;line-height: 42px;}
li.pad.wx-pay-2024-5 > span {display: block;line-height: 42px;}
.wx-pay-2024-7 {margin-bottom: 50px;display: block;}
li.pad.btn-group {padding-bottom: 100px !important;display: block;}

p.wx-pay-2024-4-3 {font-size: 32px;color: #333333;line-height: 67px;text-align: center;font-style: normal;margin-bottom: 10px;}
p.wx-pay-2024-4-2 {font-size: 20px;color: #333333;line-height: 30px;text-align: center;font-style: normal;margin-bottom: 10px;}
p.wx-pay-2024-4-5 {font-size: 20px;color: #999999;line-height: 20px;text-align: center;font-style: normal;}
img.wx-pay-2024-4-6 {width: 50%;margin: 0 auto;}
.wx-pay-2024-10 {text-align: center;display: block;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/wechat/syspay.vue